import { render } from "./back_order_channel.vue?vue&type=template&id=1f67004e"
import script from "./back_order_channel.vue?vue&type=script&lang=js"
export * from "./back_order_channel.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__